export const TEST_ID = 'clientDetailsPage';

export const CARD_HEADER_DETAIL_TYPE = 'client';

export const DETAIL_TYPE_CONTACT_NAME = 'contactName';

export const DETAIL_TYPE_EMAIL = 'email';

export const DETAIL_TYPE_PHONE = 'phone';

export const DETAIL_TYPE_FARM = 'farm';
